<template>
  <div>
    <div class="header-container fixed-top">
      <header class="header navbar navbar-expand-sm">
        <ul class="navbar-item theme-brand flex-row text-center">
          <li class="nav-item theme-logo">
            <router-link :to="homeTo" class="logo">
              <span v-if="design && design.logoType" class="logotype">
                {{ design.logoType }}
              </span>
              <img v-else alt="logo" class="navbar-logo" :src="'/assets/images/logo_white.png'" />
            </router-link>
          </li>
        </ul>
        <span v-if="appEnv !== 'PROD'" class="badge badge-danger">{{ $t("header.environment") }} - {{ appEnv }}</span>

        <div class="navbar-item flex-row align-items-center">
          <div v-if="switched" class="pe-0 pe-md-5 d-flex align-items-center" style="color: white">
            <div class="d-none d-md-block">
              {{ $t("admin.switchAdmin") }}
              <span class="fw-semibold">{{ user.fullName }}</span>
            </div>
            <button
              class="usurp bgStyle ms-2"
              v-if="switchedFrom === 'front'"
              v-tooltip="{
                title: $t('back_to_my_account'),
                position: 'bottom',
              }"
              @click="restoreUser()"
            >
              <FontAwesomeIcon icon="'fa-light fa-user" />
            </button>
          </div>

          <div
            v-if="user && user.roles && user.roles.length && user.roles.includes('ROLE_STUDEA_ADMIN')"
            class="dark-mode d-flex align-items-center"
          >
            <router-link :to="to" class="switchAdmin">
              <label class="switchAdmin__label" for="switch-admin">
                <span class="d-none d-md-inline">Admin</span>
                <FontAwesomeIcon class="d-inline d-md-none" icon="fa-light fa-cog" />
              </label>
              <SwitchTypeComponent :model="switchModel" />
            </router-link>
          </div>

          <NotificationsComponent v-if="(user && Object.keys(user).length) || apiConnection().getMagicLinkToken()" />
          <SelectLanguageComponent :isUser="user && Object.keys(user).length" />
          <div class="dropdown nav-item user-profile-dropdown btn-group" v-if="user && Object.keys(user).length">
            <a
              id="ddluser"
              aria-expanded="false"
              class="dropdown-toggle btn-icon-only user nav-link"
              data-bs-toggle="dropdown"
            >
              <AvatarComponent v-if="Object.keys(user).length" :user="user" :profile="userProfileName" />
            </a>
            <ul aria-labelledby="ddluser" class="dropdown-menu dropdown-menu-right">
              <li role="presentation">
                <router-link
                  v-if="user && user.id"
                  :to="{
                    name: 'profile',
                    params: { id: user.cryptedId },
                  }"
                  class="dropdown-item"
                >
                  <svg
                    class="feather feather-user"
                    fill="none"
                    height="24"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  {{ $t("admin.profile") }}
                </router-link>
              </li>
              <li role="presentation">
                <button v-if="dark_mode === 'light'" class="dropdown-item" @click="toggleMode('dark')">
                  <FontAwesomeIcon class="icon" icon="fa-light fa-moon" />
                  {{ $t("global.dark") }}
                </button>
                <button v-if="dark_mode === 'dark'" class="dropdown-item" @click="toggleMode('system')">
                  <FontAwesomeIcon class="icon" icon="fa-light fa-airplay" />
                  {{ $t("system") }}
                </button>
                <button v-if="dark_mode === 'system'" class="dropdown-item" @click="toggleMode('light')">
                  <FontAwesomeIcon class="icon" icon="fa-light fa-sun-bright" />
                  {{ $t("global.light") }}
                </button>
              </li>
              <li role="presentation">
                <a href="javascript:" class="dropdown-item" @click="logout">
                  <svg
                    class="feather feather-log-out"
                    fill="none"
                    height="24"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  {{ $t("logout") }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>
      <div id="sub-header" class="sub-header-container">
        <div class="header navbar navbar-expand">
          <a
            v-if="isAdminPage"
            class="sidebarCollapse d-block"
            data-placement="bottom"
            href="javascript:void(0);"
            @click="closeSideBar()"
          >
            <svg
              class="feather feather-menu"
              fill="none"
              height="24"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="3" x2="21" y1="12" y2="12"></line>
              <line x1="3" x2="21" y1="6" y2="6"></line>
              <line x1="3" x2="21" y1="18" y2="18"></line>
            </svg>
          </a>
          <BreadCrumbComponent :admin="isAdminPage" />
          <div
            v-if="$route.query.breadcrumbName"
            class="trainingCourse textStyle text-center"
            v-html="$route.query.breadcrumbName"
            :style="'max-width:' + trainingCourseWidth + 'px; margin-left:' + breadcrumbWidth + 'px'"
          ></div>
          <div
            v-if="displayTrainingCourseName()"
            class="trainingCourse textStyle text-md-center"
            :style="'max-width:' + trainingCourseWidth + 'px; margin-left:' + breadcrumbWidth + 'px'"
          >
            <span>
              {{ trainingCourse.displayName }}
              <button
                v-if="guideId"
                v-tooltip="{ title: $t('guide.show') }"
                class="ms-2 btn btn-icon"
                type="button"
                @click="getGuideToShow()"
              >
                <FontAwesomeIcon icon="fa-light fa-lightbulb-exclamation-on" />
              </button>
            </span>
          </div>
          <div
            v-if="this.$router.currentRoute.value.path === '/dashboard/training-course-list'"
            class="trainingCourse text-center welcome"
            :style="'max-width:' + trainingCourseWidth + 'px; margin-left:' + breadcrumbWidth + 'px'"
          >
            <div
              class="d-md-block d-none"
              v-html="
                $tc('dashboard.welcome_message', {
                  name: user && user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : '',
                })
              "
            ></div>
            <div class="d-md-none d-block fw-bold">{{ user.firstName }} {{ user.lastName }}</div>
            <div v-if="Object.keys(trainingCourseList).length" class="subTitle" v-html="getSubTitle()"></div>
          </div>
          <div class="logo-ufa d-md-block d-none">
            <img
              v-if="logoCfa || logoCfaPromotion"
              alt="Logo CFA"
              :src="logoCfaPromotion ? logoCfaPromotion : logoCfa"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvatarComponent from "@/components/utilities/AvatarComponent.vue";
import { mapActions, mapState } from "pinia";
import { userManager } from "@/services/security/user-manager";
import { colorManager } from "@/services/platform/color-manager";
import BreadCrumbComponent from "@/components/BreadCrumbComponent.vue";
import SwitchTypeComponent from "@/components/form/SwitchTypeComponent.vue";
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";
import { useThemeStore } from "@/store/theme/theme";
import { useTrainingCourseStore } from "@/store/training-course/training-course";
import { useTriadStore } from "@/store/triad/triad";
import { useUserStore } from "@/store/user/user";
import { usePlatformStore } from "@/store/platform/platform";
import { useMainStore } from "@/store/main/main";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import NotificationsComponent from "@/components/notifications/NotificationsComponent.vue";
import SelectLanguageComponent from "@/components/utilities/SelectLanguageComponent.vue";
import { useStudeaManagerStore } from "@/store/studea_manager/studea-manager";
import { apiConnection } from "@/services/api-connection";

export default {
  name: "HeaderComponent",
  components: {
    SelectLanguageComponent,
    NotificationsComponent,
    FontAwesomeIcon,
    SwitchTypeComponent,
    BreadCrumbComponent,
    AvatarComponent,
  },
  props: {
    isAdminPage: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["showGuide"],
  data() {
    return {
      selectedLang: {},
      switched: false,
      switchedFrom: "",
      trainingCourseWidth: 0,
      breadcrumbWidth: 0,
      switchModel: {
        vars: {
          label: false,
          name: "admin-switch",
          id: "admin-switch",
          value: false,
        },
      },
      to: {
        name: this.$route.path.includes("admin") ? "TrainingCourseList" : "adminHome",
      },
      homeTo: { name: "Dashboard" },
      windowWidth: window.innerWidth,
      guideId: null,
    };
  },
  computed: {
    ...mapState(useThemeStore, {
      countryList: (store) => store.countryList,
      dark_mode: (store) => store.dark_mode,
    }),
    ...mapState(useTrainingCourseStore, {
      trainingCourse: (store) => store.trainingCourse,
      trainingCourseList: (store) => store.trainingCourseList,
    }),
    ...mapState(useTriadStore, {
      triad: (store) => store.triad,
    }),
    ...mapState(useUserStore, {
      user: (store) => store.user,
      userProfileName: (store) => store.userProfileName,
    }),
    ...mapState(usePlatformStore, {
      logoCfa: (store) => store.logoCfa,
      logoCfaPromotion: (store) => store.logoCfaPromotion,
      design: (store) => store.design,
      guides: (store) => store.guides,
    }),
    ...mapState(useMainStore, {
      isMobile: (store) => store.isMobile,
      appEnv: (store) => store.appEnv,
    }),
    ...mapState(useStudeaManagerStore, {
      trainingName: (store) => store.trainingName,
    }),
  },
  mounted() {
    this.setBreadcrumbWidth();
    this.selectedLang = window.$appSetting.toggleLanguage();
    this.toggleMode();
    this.setSwitchAdmin();
    this.setHomeTo();
    this.switched = sessionStorage.getItem("studea-switched") === "1";
    this.switchedFrom = sessionStorage.getItem("studea-initial-token") ? "front" : "zama";
    window.addEventListener("resize", this.updateWindowWidth);
  },

  unmounted() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  updated() {
    this.setSizeTrainingCourseWidth();
    this.setBreadcrumbWidth();
  },
  watch: {
    $route(to, from) {
      this.watchSwitchAdmin(to, from);
      this.setHomeTo();
      this.findGuideFromUrl();
    },
    isMobile() {
      this.setBreadcrumbWidth();
    },
    windowWidth() {
      this.setSizeTrainingCourseWidth();
    },
    guides() {
      this.findGuideFromUrl();
    },
  },
  methods: {
    apiConnection() {
      return apiConnection;
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },

    setBreadcrumbWidth() {
      const crumb = document.querySelector(".page-header");
      if (!this.isMobile) {
        if (crumb && crumb.offsetWidth - 150 > 0) {
          this.breadcrumbWidth = crumb.offsetWidth - 150;
        } else {
          this.breadcrumbWidth = 0;
        }
      } else if (window.innerWidth > 768) {
        this.breadcrumbWidth = 0;
      } else {
        this.breadcrumbWidth = 25;
      }
    },

    setSizeTrainingCourseWidth() {
      let container = document.getElementById("sub-header");
      let logo = document.querySelector(".logo-ufa");
      let crumb = document.querySelector(".page-header");

      let containerWidth = null;
      if (window.innerWidth < 768) {
        this.trainingCourseWidth = "";
      } else if (crumb && container && logo) {
        containerWidth = container.offsetWidth - 90;
        let offset = logo.offsetWidth + (crumb.offsetWidth + 100);
        this.trainingCourseWidth = containerWidth - offset;
      } else if (container && logo) {
        containerWidth = container.offsetWidth - 42;
        this.trainingCourseWidth = containerWidth - 2 * logo.offsetWidth;
      }
    },

    restoreUser() {
      studeaManagerManager.restoreUser();
      this.switched = sessionStorage.getItem("studea-switched") === "0";
    },

    logout() {
      userManager.logout();
    },

    toggleMode(mode) {
      window.$appSetting.toggleMode(mode);
      colorManager.setPlatformStyle(null, this.design);
    },

    getSubTitle() {
      let label = "";
      switch (this.user.type) {
        case "tutor":
          label = this.$tc("tutorPart", Object.keys(this.trainingCourseList).length, {
            number: Object.keys(this.trainingCourseList).length,
          });
          break;
        case "apprentice_master":
          label = this.$tc("apprenticeMasterPart", Object.keys(this.trainingCourseList).length, {
            number: Object.keys(this.trainingCourseList).length,
          });
          break;
        case "lea_manager":
          label = this.$tc("studeaManagerPart", Object.keys(this.trainingCourseList).length, {
            number: Object.keys(this.trainingCourseList).length,
          });
          break;
      }

      return label;
    },

    setHomeTo() {
      if (this.$route.matched.find((item) => item.name === "adminLayout")) {
        this.homeTo = { name: "adminHome" };
      } else if (this.$route.matched.find((item) => item.name === "studeaManagerLayout")) {
        this.homeTo = {
          name: "studeaManagerHome",
          params: {
            trainingCourseId: this.$route.params.trainingCourseId,
          },
        };
      } else if (!this.user || !Object.keys(this.user).length) {
        this.homeTo = { name: "Login" };
      } else {
        if (this.user && this.user.target !== "triad") {
          this.homeTo = { name: "TrainingCourseList" };
        } else {
          this.homeTo = { name: "Dashboard" };
        }
      }
    },

    setSwitchAdmin() {
      if (this.$route.matched.find((item) => item.name === "adminLayout")) {
        this.switchModel.vars.value = true;
      }
      if (
        window.localStorage.getItem("studea-returnPathName") &&
        this.$route.matched.find((item) => item.name === "adminLayout")
      ) {
        this.to = JSON.parse(window.localStorage.getItem("studea-returnPathName"));
      }
    },

    watchSwitchAdmin(to, from) {
      if (
        to.matched.find((item) => item.name === "adminLayout") &&
        !from.matched.find((item) => item.name === "adminLayout")
      ) {
        this.switchModel.vars.value = true;
        this.to = {
          name: from.name,
          params: from.params,
          query: from.query,
        };
        window.localStorage.setItem("studea-returnPathName", JSON.stringify(this.to));
      } else {
        if (!to.matched.find((item) => item.name === "adminLayout")) {
          this.switchModel.vars.value = false;
          this.to = { name: "adminHome" };
        }
      }
    },

    back() {
      if (this.$router.currentRoute.value.name !== "Login" && this.$router.currentRoute.value.name !== "Dashboard") {
        this.$router.back();
      }
    },

    closeSideBar() {
      this.toggleSideBar();
    },

    displayTrainingCourseName() {
      return (
        this.trainingCourse &&
        this.trainingCourse.displayName &&
        !this.$router.currentRoute.value.matched.find((item) => item.path === "/admin") &&
        !this.$router.currentRoute.value.matched.find((item) => item.path === "/training") &&
        !this.$router.currentRoute.value.matched.find((item) => item.name === "RegistrationLayoutView") &&
        !this.$router.currentRoute.value.matched.find((item) => item.name === "Registration") &&
        this.$router.currentRoute.value.path !== "/dashboard/training-course-list" &&
        this.$router.currentRoute.value.path !== "/training/list" &&
        ![
          "studeaManagerIncidentSheetList",
          "studeaManagerSharedDocumentList",
          "trainingCourseDuplicateView",
          "driverLicenceList",
        ].includes(this.$route.name)
      );
    },

    findGuideFromUrl() {
      const guideFindFromUrl = this.guides.find((element) => element.url === window.location.pathname);
      if (guideFindFromUrl) {
        this.guideId = guideFindFromUrl.id;
      } else {
        this.guideId = null;
      }
    },

    getGuideToShow() {
      if (this.guideId) {
        this.$emit("showGuide", this.guideId);
      }
    },

    ...mapActions(useMainStore, { toggleSideBar: "toggleSideBar" }),
  },
};
</script>

<style lang="scss" scoped>
header.header {
  background: var(--primary-color);
  flex-wrap: nowrap;
  position: relative;
}

.navbar-logo {
  @include up-to-md {
    height: 35px !important;
  }
}

.trainingCourse {
  font-weight: 700;
  font-size: 16px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.6;
  width: 100%;

  @include up-to-md {
    position: static;
    transform: translate(0, 0);
  }

  span {
    width: 100%;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: wrap;
    overflow: visible;
    line-height: 1.3;

    @include up-to-md {
      white-space: nowrap;
      overflow: hidden;
    }
  }

  @include up-to-md {
    line-height: 1.2;
    align-items: start;
    font-size: 14px;
    padding-right: 75px;
  }

  &.welcome {
    font-weight: 400;

    strong {
      font-weight: 800 !important;
    }
  }

  .subTitle {
    font-size: 15px;

    @include up-to-md {
      font-size: 12px;
    }
  }
}

.icon {
  width: 18px;
  height: 18px;
}

.backToTriad {
  position: absolute;
  white-space: nowrap;
  font-weight: 700;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.switchAdmin {
  display: flex;
  align-items: center;

  &__label > span {
    color: $white !important;
  }

  svg {
    @include up-to-md {
      width: 18px !important;
      margin-top: 2px;
    }
  }
}

.logo-ufa {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
  height: 50px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.logotype {
  font-size: 33px;
  color: $white;
  letter-spacing: 3px;
  position: relative;
  font-weight: 600;
  top: -1px;
  text-transform: uppercase;
}

.usurp {
  background: none;
  border: none;
  border-radius: 6px;
  width: 30px;
  height: 30px;
  color: $white;
  font-size: 18px;
  transition: all 300ms ease-in-out;

  &:hover {
    background: $white;
    color: var(--primary-color);
  }
}
</style>
